import { Pipe, PipeTransform } from '@angular/core';
import { CmRoutingService } from '@cm/core/routing';

@Pipe({
    name: 'cmLinkFromRoot',
    standalone: false
})
export class CmLinkFromRootPipe implements PipeTransform {
	constructor(private readonly cmRouting: CmRoutingService) {}

	transform(path: string[] | string): string | string[] {
		if (typeof path === 'string') {
			const base = this.cmRouting.routeWithContext([]);
			return '/' + base.join('/') + '/' + path;
		} else {
			return ['/', ...this.cmRouting.routeWithContext(path)];
		}
	}
}
